const castStringAsBoolean = (string: string) =>
  string === "true" ? true : false;

const readVpnManagerUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_VPN_MANAGER_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readClientConfigurationUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_CLIENT_CONFIGURATION_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readRoleManagerUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_ROLE_MANAGER_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readSupportUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_SUPPORT_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readUserManagerUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_USER_MANAGER_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readOtaUpdatesUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_OTA_UPDATES_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readMachineEventsUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_MACHINE_EVENTS_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readAlarmsUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_ALARMS_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readBlueprintsUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_BLUEPRINTS_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readDashboardsUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_DASHBOARDS_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readQuerytimescaleUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_QUERYTIMESCALE_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readRagUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_RAG_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readVncWebsocketUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_VNC_WEBSOCKET_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readFeatureFlagsUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_FEATURE_FLAGS_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readNamespaceConfigurationUrlEnvVar = (defaultValue: any) => {
  try {
    return ENV_NAMESPACE_CONFIGURATION_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForCallRealApi = (defaultValue: any) => {
  try {
    return castStringAsBoolean(ENV_CALL_REAL_API);
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForAppURL = (defaultValue: any) => {
  try {
    return window.__RUNTIME_CONFIG__?.APP_URL || ENV_APP_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForAuthAuthority = (defaultValue: any) => {
  try {
    return window.__RUNTIME_CONFIG__?.AUTH_AUTHORITY || ENV_AUTH_AUTHORITY;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForAuthClientId = (defaultValue: any) => {
  try {
    return window.__RUNTIME_CONFIG__?.AUTH_CLIENT_ID || ENV_AUTH_CLIENT_ID;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForZendeskSupportUrl = (defaultValue: any) => {
  try {
    return ENV_ZENDESK_SUPPORT_URL;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForAuthService = (defaultValue: any) => {
  try {
    return ENV_AUTH_SERVICE;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForSentryDsn = (defaultValue: any) => {
  try {
    return ENV_SENTRY_DSN;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForSentryEnv = (defaultValue: any) => {
  try {
    return ENV_SENTRY_ENVIRONMENT;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForOtelEnable = (defaultValue: any) => {
  try {
    return castStringAsBoolean(ENV_OTEL_ENABLE);
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForOtelServiceName = (defaultValue: any) => {
  try {
    return ENV_OTEL_SERVICE_NAME;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForOtelServiceVersion = (defaultValue: any) => {
  try {
    return ENV_OTEL_SERVICE_VERSION;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForOtelExporterOtlpEndpoint = (
  defaultValue: any,
) => {
  try {
    return ENV_OTEL_EXPORTER_OTLP_ENDPOINT;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

const readEnvVarOrSetDefaultForOtelExporterAuthToken = (defaultValue: any) => {
  try {
    return ENV_OTEL_EXPORTER_AUTH_TOKEN;
  } catch (e) {
    if (e instanceof ReferenceError) {
      return defaultValue;
    }
  }
};

export const callRealApi = () => readEnvVarOrSetDefaultForCallRealApi(true);
export const appUrl = () => readEnvVarOrSetDefaultForAppURL("");

export const readAuthServiceEnvVar = () => {
  return readEnvVarOrSetDefaultForAuthService("zitadel");
};
export const readAuthAuthorityEnvVar = () =>
  readEnvVarOrSetDefaultForAuthAuthority(
    "https://tomorrowthings-dev-6kyjnl.zitadel.cloud",
  );
export const readAuthClientIdEnvVar = () =>
  readEnvVarOrSetDefaultForAuthClientId(
    "258993721968801896@tomorrowthings-cloud-connect",
  );

export const readZendeskSupportUrlEnvVar = () =>
  readEnvVarOrSetDefaultForZendeskSupportUrl(
    "https://support.tomorrowthings.com",
  );

export const readSentryDsnEnvVar = () =>
  readEnvVarOrSetDefaultForSentryDsn(
    "https://7ca112c0aa2063ba76e19f94d78ba3f8@o4505311452856320.ingest.us.sentry.io/4509327149629440",
  );

export const roleManagerUrlEnvVar = () =>
  readRoleManagerUrlEnvVar("https://api.tomorrowthings.dev/rolemanager");

export const otaUpdatesUrlEnvVar = () =>
  readOtaUpdatesUrlEnvVar("https://api.tomorrowthings.dev/ota-updates");

export const machineEventsUrlEnvVar = () =>
  readMachineEventsUrlEnvVar("https://api.tomorrowthings.dev/machineevents");

export const alarmsUrlEnvVar = () =>
  readAlarmsUrlEnvVar("https://api.tomorrowthings.dev/alarms");

export const blueprintsUrlEnvVar = () =>
  readBlueprintsUrlEnvVar("https://api.tomorrowthings.dev/blueprints");

export const dashboardsUrlEnvVar = () =>
  readDashboardsUrlEnvVar("https://api.tomorrowthings.dev/dashboards");

export const querytimescaleUrlEnvVar = () =>
  readQuerytimescaleUrlEnvVar("https://api.tomorrowthings.dev/querytimescale");

export const userManagerUrlEnvVar = () =>
  readUserManagerUrlEnvVar("https://api.tomorrowthings.dev/usermanager");

export const vncWebsocketUrlEnvVar = () =>
  readVncWebsocketUrlEnvVar("wss://api.tomorrowthings.dev/vncwebsocket");

export const featureFlagsUrlEnvVar = () =>
  readFeatureFlagsUrlEnvVar("https://api.tomorrowthings.dev/featureflags");

export const vpnManagerUrlEnvVar = () =>
  readVpnManagerUrlEnvVar("https://api.tomorrowthings.dev/vpnmanager");

export const supportUrlEnvVar = () =>
  readSupportUrlEnvVar("https://api.tomorrowthings.dev/support");

export const ragUrlEnvVar = () =>
  readRagUrlEnvVar("https://api.tomorrowthings.dev/chatbot");

export const namespaceConfigurationUrlEnvVar = () =>
  readNamespaceConfigurationUrlEnvVar(
    "https://api.tomorrowthings.dev/namespaceconfiguration",
  );

//todo : change later the actual one
export const clientConfigurationUrlEnvVar = () =>
  readClientConfigurationUrlEnvVar(
    "https://api.tomorrowthings.dev/clientconfiguration",
  );

export const readSentryEnvVar = () => readEnvVarOrSetDefaultForSentryEnv("dev");

export const otelEnableEnvVar = () =>
  readEnvVarOrSetDefaultForOtelEnable(false);

export const otelServiceNameEnvVar = () =>
  readEnvVarOrSetDefaultForOtelServiceName("things-os-frontend");

export const otelServiceVersionEnvVar = () =>
  readEnvVarOrSetDefaultForOtelServiceVersion("unknown");

export const otelExporterOtlpEndpointEnvVar = () =>
  readEnvVarOrSetDefaultForOtelExporterOtlpEndpoint(
    "https://ingress.europe-west4.gcp.dash0.com/v1/traces",
  );

export const otelExporterAuthTokenEnvVar = () =>
  readEnvVarOrSetDefaultForOtelExporterAuthToken("");
